import { APP_RELEASE_DATE, APP_VERSION } from '../app/release.js';

export default function ReleaseNote() {
  return (
    <span className="release-note" title="Filter DevTools console for dechess — yellow warn lines">
      v{APP_VERSION} · {APP_RELEASE_DATE} · console: dechess
    </span>
  );
}
